/* eslint-disable no-console */

/**
 * Fiance Section - used on the new vehicle VDP
 * https://app.asana.com/0/848875433820573/1202160104097588/f
 */
((window, document) => {
  window.dataLayer = window.dataLayer || [];

  // Active offer class
  const ACTIVE_OFFER_CLASS = 'thisOne';
  // Default hide class
  const HIDE_CLASS = 'hide__default';
  // Set the spinner visible value
  let isSpinnerVisible = false;
  // Get the tabs navigation
  const tabsNavigation = document.querySelector('.js-tabs__navigation');
  // Get the contract hire table
  const leaseTable = document.querySelector('.js-content-toggle-tabs .js-lease-table');
  // const leaseContainer = document.querySelector('.js-content-toggle-tabs #lease');
  // eslint-disable-next-line max-len
  // const leaseOfferActive = leaseContainer ? leaseContainer.classList.contains(ACTIVE_OFFER_CLASS) : false;

  // function capitalizeFirstLetter(string) {
  //   return string.charAt(0).toUpperCase() + string.slice(1);
  // }

  /**
   * renamePropertyName
   *
   * Some properties might need renaming for the datalayer object
   * to have a similar structure for all finance types
   *
   * @param {string} paramName
   * @return {string} newParamName
   */
  function renamePropertyName(paramName) {
    switch (paramName) {
      case 'mileage':
        return 'annualMileage';
      case 'term':
        return 'durationOfAgreement';
      default:
        return paramName;
    }
  }

  /**
   * parseFinanceTable
   *
   * Parses finance table into an object of camel-cased parameters
   *
   * @param {HTMLElement} financeTableElement
   * @param {(el:HTMLElement, tableData: {}) => {}} outlierHandlerCallback
   * Handles any rows that have only one value
   * @return {{}} financeTable
   */
  function parseFinanceTable(financeTableElement, outlierHandlerCallback) {
    if (!financeTableElement) return {};

    const tableData = {};
    const rows = financeTableElement.getElementsByTagName('tr');

    Array.from(rows).forEach((tr) => {
      const tds = tr.getElementsByTagName('td');

      if (tds[1]) {
        const [rowText, rowValue] = tds;
        // const paramsTranformer = (word, i) => i === 0 ?
        // word.toLowerCase() : capitalizeFirstLetter(word);

        const paramName = rowText.innerText
          .replace(/[0-9]/g, '')
          .trim()
          .split(' ')
          // .map(paramsTranformer)
          .join('')
          .trim();

        tableData[renamePropertyName(paramName)] = rowValue.innerText.trim();
      } else if (tds[0]) {
        // This row only has one value, so let the caller decide what to do
        outlierHandlerCallback.bind(this, tds[0], tableData);
      }
    });
    return tableData;
  }

  function fireDataLayer(financeObject) {
    window.dataLayer.push(financeObject);
  }

  /**
   * buildSessionObject
   *
   * @param {HTMLElement} activeOfferContainer
   * @param {'cash'|'finance'|'lease'} financeType
   */
  function buildSessionObject(activeOfferContainer, financeType = '') {
    let financeObject = {};

    const defaultFinanceObject = {
      customerDeposit: '',
      initialRental: '',
      monthlyPaymentsOf: '',
      monthlyRentalsOf: '',
      cashPrice: '',
      amountOfCredit: '',
      fees: '',
      optionalFinalPayment: '',
      totalAmountPayable: '',
      durationOfAgreement: '',
      annualMileage: '',
      fixedRateOfInterest: '',
      representativeAPR: '',
      financeDepositAllowance: '',
    };

    // cash/finance/lease to cash/PCP/HP/PCH
    let specificFinanceType = financeType;
    const table = activeOfferContainer.querySelector(`.${ACTIVE_OFFER_CLASS} .finance-table`);
    const price = activeOfferContainer.querySelector(`.${ACTIVE_OFFER_CLASS} .js-price`);
    const cashPriceOnly = document.querySelector('.js-price');

    switch (financeType) {
      case 'finance':
        // PCP or HP
        specificFinanceType = 'PCP';
        financeObject = parseFinanceTable(table, (singleTd, tableData) => {
          if (singleTd.innerText.includes('APR')) {
            tableData.representativeAPR = singleTd.querySelector('span').innerText.trim();
          }
        });
        break;
      case 'cash':
        financeObject.cashPrice = price
          ? price.innerText.split('\n')[0]
          : cashPriceOnly.innerText.split('\n')[0];
        break;
      case 'hire':
        specificFinanceType = 'BCH';
        financeObject = parseFinanceTable(leaseTable);
        break;
      case 'lease':
        specificFinanceType = 'PCH';
        financeObject = parseFinanceTable(leaseTable);
        break;
      default:
        console.warn('finance type error');
    }

    // Only push to datalayer when there is actual data
    if (Object.keys(financeObject).length > 0) {
      financeObject = {
        financeType: specificFinanceType,
        ...defaultFinanceObject,
        ...financeObject,
      };

      sessionStorage.setItem('_financeDetails', JSON.stringify(financeObject));
      fireDataLayer(financeObject);
    }
  }

  /**
   * Set the offer details and send a custom event to the
   * window so we can access the details in other components
   * @param {string} label - The finance type label
   * @param {string} price - The finance amount
   */
  function setOfferDetail(label, price) {
    const offerDetail = {
      label,
      price,
    };

    window.dispatchEvent(
      new CustomEvent('activeOffer', {
        bubbles: true,
        detail: {
          offerDetail,
        },
      }),
    );
  }

  /**
   * Handle multiple finance offers, if there are muiltiple search
   * for the active offer to hide it
   */
  function handleMultipleFinanceOffers() {
    try {
      const financeOfferSections = document.querySelectorAll('.js-finance-offer__item');
      const financeOfferSectionsWithOffer = !!document.querySelectorAll(
        `.js-finance-offer__item .${ACTIVE_OFFER_CLASS}`,
      ).length;

      if (financeOfferSectionsWithOffer) {
        financeOfferSections.forEach((section) => {
          const isOfferActive = section.classList.contains(ACTIVE_OFFER_CLASS);

          if (isOfferActive) {
            section.classList.remove(HIDE_CLASS);
          } else {
            section.classList.add(HIDE_CLASS);
          }
        });
      }
    } catch (err) {
      window.vm.debug.error(err);
    }
  }

  /**
   * Handle the active offer details
   */
  function handleActiveOfferDetails() {
    try {
      const activeTabId = tabsNavigation
        ?.querySelector('.tabs__item.is-active')
        .getAttribute('href')
        .replace('#', '');
      const activeOfferContainer = tabsNavigation?.parentElement.querySelector(`#${activeTabId}`);
      const activeOfferId = activeOfferContainer?.id;
      let hasVAT = false;
      let priceTitle = activeOfferContainer?.querySelector('.js-price-title');
      let price = activeOfferContainer?.querySelector('.js-price');
      const isLeaseOffer = activeOfferId === 'lease';
      const cashOffer = activeOfferId === 'cash';
      const hireOffer = activeOfferId === 'hire';
      const isMotability = window.location.href.includes('motability');

      // If the page is Motability then get the price and title then return
      if (isMotability) {
        priceTitle = document.querySelector('.js-price-title');
        price = document.querySelector('.js-price');
        setOfferDetail(priceTitle.innerText, price.innerText);
        return;
      }

      // Handle multipel offers
      const multipleFinanceOffers = document.querySelectorAll('.js-finance-offer__item');
      if (
        multipleFinanceOffers.length > 1 &&
        activeOfferId !== 'cash' &&
        activeOfferId !== 'lease' &&
        activeOfferId !== 'hire'
      ) {
        // Check whether there is multiple finance offers and check which is active
        const hasOffer = [...multipleFinanceOffers].filter((el) =>
          el.classList.contains(ACTIVE_OFFER_CLASS),
        );
        // If there is an active offer, get the price title and price from the active offer
        if (hasOffer) {
          priceTitle = activeOfferContainer?.querySelector(
            `.${ACTIVE_OFFER_CLASS} .js-price-title`,
          );
          price = activeOfferContainer?.querySelector(`.${ACTIVE_OFFER_CLASS} .js-price`);
          buildSessionObject(activeOfferContainer, 'finance');
        }
      }

      // Handle cash offers
      if (cashOffer) {
        buildSessionObject(activeOfferContainer, 'cash');
      }

      // If there's a lease offer, check whether it has the VAT sub label so
      // we can populate the finance event object to display in the sticky overview
      if (isLeaseOffer) {
        const priceGroupContainer = activeOfferContainer?.querySelector('.price-group-container');
        hasVAT = priceGroupContainer?.innerText.includes('VAT');

        buildSessionObject(activeOfferContainer, 'lease');
      }

      // If there's a hire offer, check whether it has the VAT sub label so
      // we can populate the finance event object to display in the sticky overview
      if (hireOffer) {
        const priceGroupContainer = activeOfferContainer?.querySelector('.price-group-container');
        hasVAT = priceGroupContainer?.innerText.includes('VAT');

        buildSessionObject(activeOfferContainer, 'hire');
      }

      if (priceTitle && price) {
        // eslint-disable-next-line max-len
        setOfferDetail(
          cashOffer ? 'Cash price' : priceTitle.innerText,
          `${price.innerText.replace(/[\r\n]/gm, '')} ${hasVAT ? '+VAT' : ''}`,
        );
      }
    } catch (err) {
      window.vm.debug.error(err);
    }
  }

  /**
   * If there isn't a cash offer, hide the cash offer elements
   */
  function handleCashOffer() {
    const cashOfferElements = document.querySelectorAll('.js-cash-offer');
    const noOfferFallback = document.querySelector('.js-no-offer-fallback');
    if (cashOfferElements && noOfferFallback) {
      cashOfferElements.forEach((el) => {
        if (el.querySelector('.price-group-container')) {
          noOfferFallback.classList.add(HIDE_CLASS);
          tabsNavigation.classList.add(HIDE_CLASS);
        } else if (el.querySelector('.js-no-offer')) {
          el.classList.add(HIDE_CLASS);
          tabsNavigation.classList.add(HIDE_CLASS);
        }
      });
    }
  }

  /**
   * If there's no finance offers, then hide the finance section
   */
  function handleNoFinanceOffers() {
    const financeToggleItem = document.querySelector('.js-finance-toggle__item');
    const leaseToggleItem = document.querySelector('.js-lease-toggle__item');
    const hireToggleItem = document.querySelector('.js-hire-toggle__item');

    if (
      leaseToggleItem?.classList.contains(HIDE_CLASS) &&
      financeToggleItem?.classList.contains(HIDE_CLASS) &&
      hireToggleItem?.classList.contains(HIDE_CLASS)
    ) {
      const financeYourVehicleSection = document.querySelector('.js-finance-you-vehicle-section');
      financeYourVehicleSection.classList.add(HIDE_CLASS);
      tabsNavigation.style.display = 'none';
    }
  }

  /**
   * Build the lease offer with the values from the offer record
   * Append the lease offer table with the values
   */
  function buildLeaseOffer() {
    const leaseInitialRental = document.querySelector('.js-initial-rental');
    const leaseOffer = document.querySelector('.js-lease-offer');
    const leaseOfferString = leaseOffer?.innerText;
    const hasVAT = leaseOfferString.includes('+VAT');
    const leaseOfferTBody = document.createElement('tbody');
    const leaseFragment = new DocumentFragment();
    const leaseOfferArr = [];

    // We need to remove commas from the lease string, then
    // get all the numbers and convert to a number. We then add the
    // commas if neccessary and push to the lease offer array
    if (leaseOfferString) {
      leaseOfferString
        .replace(/,/g, '')
        .match(/[0-9]+/g)
        .forEach((num) => {
          const convertedNumber = +num;
          leaseOfferArr.push(convertedNumber.toLocaleString());
        });
    }

    // If the lease rental element is present
    if (leaseInitialRental) {
      // If the spinner isn't visible, add it
      if (!isSpinnerVisible) {
        leaseInitialRental.innerHTML = `
          <div class="spinner-container spinner-container--small js-spinner">
            <div class="spinner-fade spinner-fade--center"></div>
          </div>`;
        isSpinnerVisible = true;
      }

      // Set a small timeout to show the spinner
      // then set the innerHTML with the price
      setTimeout(() => {
        leaseInitialRental.innerHTML = `£${leaseOfferArr[0]}`;
      }, 250);
    }

    const leaseOfferTemplate = `
      <tr>
        <td>Initial rental</td>
        <td>£${leaseOfferArr[0]} 
          ${hasVAT ? '<span>+VAT</span>' : ''}
        </td>
      </tr>
      <tr>
        <td><span class="term">${leaseOfferArr[1]}</span> monthly rentals of</td>
        <td>£${leaseOfferArr[2]} 
          ${hasVAT ? '<span>+VAT</span>' : ''}
        </td>
      </tr>
      <tr>
        <td>Term</td>
        <td>${Number(leaseOfferArr[1]) + 1} months</td>
      </tr>
      <tr>
        <td>Mileage</td>
        <td>${leaseOfferArr[3]}*</td>
      </tr>
    `;

    leaseOfferTBody.innerHTML = leaseOfferTemplate;
    leaseFragment.appendChild(leaseOfferTBody);
    leaseTable.appendChild(leaseFragment);
  }

  /**
   * Get the disclaimer from the current offer
   * and append it to the bottom of the table
   */
  function handleOfferDisclaimer() {
    try {
      const offerDisclaimer = document.querySelector('.js-disclaimer');
      const financeTableDisclaimer = document.querySelector(
        '.js-finance-table-container-disclaimer',
      );
      if (offerDisclaimer && financeTableDisclaimer) {
        financeTableDisclaimer.innerHTML = offerDisclaimer.innerHTML;
      }
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * Initlaise the finance section
   */
  function initialiseFinanceSection() {
    let leaseTableEmpty;
    // Get the lease tab item so we can listen for the event
    const leaseTabsItem = document.querySelector('.js-tabs__item--lease');
    // If the table is present
    if (leaseTable) {
      leaseTableEmpty = leaseTable.innerHTML.trim().length <= 0;
      // Builds lease offer regardless if it's cash or lease
      if (leaseTableEmpty) {
        buildLeaseOffer();
      }
    }

    window.addEventListener('activeTab', (e) => {
      handleActiveOfferDetails();
      if (leaseTable) {
        leaseTableEmpty = leaseTable.innerHTML.trim().length <= 0;
        if (
          e.detail.target &&
          (e.detail.target.id === 'lease' ||
            e.detail.target.id === leaseTabsItem.getAttribute('href').replace('#', '')) &&
          leaseTableEmpty
        ) {
          buildLeaseOffer();
        }
      }
    });

    handleOfferDisclaimer();
    handleCashOffer();
    handleNoFinanceOffers();
    handleActiveOfferDetails();
    handleMultipleFinanceOffers();
  }

  vm.onload(initialiseFinanceSection);
})(window, document);
